import { FORM_IDS } from 'providers/LoginProvider';
import { useCallback, useState } from 'react';
import { hasValue } from 'swipeclock-frontend';

export const useFormValidation = () => {
  const [errors, setErrors] = useState({});

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d\W]).{8,}$/;

  const validationCallbackLogin = useCallback((id, value) => {
    let error = null;

    const idRegex = /^\d*$/;

    switch (id) {
      case FORM_IDS.USERNAME:
        if (!hasValue(value)) {
          error = 'username is required.';
        }
        break;
      case FORM_IDS.PASSWORD:
        if (!hasValue(value)) {
          error = 'Password is required.';
        }
        break;
      case FORM_IDS.SITEID:
        if (
          typeof value === 'string' &&
          hasValue(value) &&
          !idRegex.test(value)
        ) {
          error = 'The entered site id must be a number';
        }
        break;
      default:
        break;
    }

    return error;
  }, []);

  const validationCallbackCodeReset = useCallback(
    (id, value, validationRef) => {
      let error = null;

      switch (id) {
        case FORM_IDS.RESETCODE:
          if (!hasValue(value)) {
            error = 'Reset code is required.';
          }
          break;
        case FORM_IDS.NEWPASSWORD:
          if (!hasValue(value)) {
            error = 'New password is required.';
          } else if (!passwordRegex.test(value)) {
            if (value.length < 8) {
              error = 'Password must contain at least 8 characters';
            } else if (!/[A-Z]/.test(value)) {
              error = 'Password must contain at least one uppercase letter.';
            } else if (!/[a-z]/.test(value)) {
              error = 'Password must contain at least one lowercase letter.';
            } else if (!/[\d\W]/.test(value)) {
              error =
                'Password must contain at least one number or special character.';
            }
          }
          break;
        case FORM_IDS.CONFIRMPASSWORD:
          if (!hasValue(value)) {
            error = 'Confirm password is required.';
          } else if (
            value !== validationRef.current[FORM_IDS.NEWPASSWORD]?.value
          ) {
            error = 'Passwords do not match.';
          }
          break;
        default:
          break;
      }

      return error;
    },
    []
  );

  const validationCallbackClockForgot = useCallback((id, value) => {
    let error = null;

    switch (id) {
      case FORM_IDS.USERNAME:
        if (!hasValue(value)) {
          error = 'Username or Clock # is required.';
        }
        break;
      case FORM_IDS.EMAIL:
        if (!hasValue(value)) {
          error = 'Email is required.';
        } else if (!emailRegex.test(value)) {
          error = 'Email must be a valid email address.';
        }
        break;
      default:
        break;
    }

    return error;
  }, []);

  const validationCallbackReset = useCallback((id, value, validationRef) => {
    let error = null;

    switch (id) {
      case FORM_IDS.NEWPASSWORD:
        if (!hasValue(value)) {
          error = 'New password is required.';
        } else if (!passwordRegex.test(value)) {
          if (value.length < 8) {
            error = 'Password must contain at least 8 characters';
          } else if (!/[A-Z]/.test(value)) {
            error = 'Password must contain at least one uppercase letter.';
          } else if (!/[a-z]/.test(value)) {
            error = 'Password must contain at least one lowercase letter.';
          } else if (!/[\d\W]/.test(value)) {
            error =
              'Password must contain at least one number or special character.';
          }
        }
        break;
      case FORM_IDS.CONFIRMPASSWORD:
        if (!hasValue(value)) {
          error = 'Confirm password is required.';
        } else if (
          value !== validationRef.current[FORM_IDS.NEWPASSWORD]?.value
        ) {
          error = 'Passwords do not match.';
        }
        break;
      default:
        break;
    }

    return error;
  }, []);

  const errorContext = {
    errors,
    setError: (id, error) =>
      setErrors((prevErrors) => ({ ...prevErrors, [id]: error })),
  };

  return {
    errorContext,
    validationCallbackLogin,
    validationCallbackCodeReset,
    validationCallbackClockForgot,
    validationCallbackReset,
    setErrors,
  };
};
